import Cart from 'cart-store';

/**
 * Board butter cart upsell.
 *
 * Shows a single discounted Brisket Board Butter offer, but only while the cart
 * holds at least one chopping board and does not already hold the butter. The
 * 25% comes off via the "Season the Board" automatic discount at checkout, so
 * this component never touches pricing itself - it only surfaces the offer.
 */
class BoardButterUpsell extends HTMLElement {
  connectedCallback() {
    this.boardIds = (this.getAttribute('board-ids') || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
    this.butterProductId = (this.getAttribute('butter-product-id') || '').trim();
    this.butterVariantId = Number(this.getAttribute('butter-variant-id'));

    this.button = this.querySelector('[data-butter-add]');
    if (this.button) {
      this.onAdd = this.onAdd.bind(this);
      this.button.addEventListener('click', this.onAdd);
    }

    this.sync(Cart.getState());
    this.unsubscribe = Cart.subscribe((state) => this.sync(state));
  }

  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
    if (this.button) this.button.removeEventListener('click', this.onAdd);
  }

  sync(state) {
    const items = state?.cart?.items || [];
    const hasBoard = items.some((item) => this.boardIds.includes(String(item.product_id)));
    const hasButter = items.some((item) => String(item.product_id) === this.butterProductId);
    const show = hasBoard && !hasButter;

    if (show && this.hidden && this.button) {
      // Reset the button whenever the offer comes back (e.g. butter removed again).
      this.button.disabled = false;
      this.button.removeAttribute('data-state');
    }
    this.hidden = !show;
  }

  async onAdd(event) {
    event.preventDefault();
    if (!this.button || this.button.disabled || !this.butterVariantId) return;

    this.button.disabled = true;
    this.button.setAttribute('data-state', 'loading');

    try {
      await Cart.add({ id: this.butterVariantId, quantity: 1 });
      // sync() hides the offer once the cart update lands.
    } catch (error) {
      this.button.disabled = false;
      this.button.setAttribute('data-state', 'error');
      console.error('Could not add board butter:', error);
    }
  }
}

if (!customElements.get('board-butter-upsell')) {
  customElements.define('board-butter-upsell', BoardButterUpsell);
}
